import { render, staticRenderFns } from "./ImportAttendance.vue?vue&type=template&id=0c112651&"
import script from "./ImportAttendance.vue?vue&type=script&lang=js&"
export * from "./ImportAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports